<template>
  <div class="product-details" v-if="sku">
    <div class="product-img">
      <img v-lazy="sku.pic_url" />
    </div>
    <div class="product-intro">
      <div class="title">{{sku.name}}</div>
      <div class="gift-name">
        <span v-if="sku.attr_list && JSON.stringify(sku.attr_list) != '{}'">
          <em v-for="(attr, index) in sku.attr_list" :key="index">{{attr.attr_value.value}}</em>
        </span>
      </div>
      <div class="product-num">数量: {{sku.sku_num}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'skuDetails',
  props: {
    sku: {
      type: Object
    }
  }
}
</script>

<style lang="less" scoped>
.product-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 0.24rem 0.45rem 0.28rem;
  border-bottom: 0.5px solid #eaeaea;
  .product-img {
    width: 2rem;
    height: 2rem;
    padding: 0.12rem;
    border: 0.5px solid #f2f2f2;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .product-intro {
    width: 4.4rem;
    height: 1.8rem;
    font-size: 0.24rem;
    .flex-column-between;
    .title {
      color: #333;
      .ellipsis2;
    }
    .gift-name {
      font-size: 0.2rem;
      color: #9b9b9b;
      display: flex;
      span {
        // width: 100%;
        padding: 0.02rem 0.08rem;
        color: #9b9b9b;
        border: 1px solid #eaeaea;
        border-radius: 0.04rem;
        background-color: #f8f8f8;
       .ellipsis;
      }
    }
    .product-price {
      display: flex;
      justify-content: space-between;
      color: #404040;
      .price {
        em {
          color: #ff2851;
        }
      }
    }
    .product-num {
      font-size: 0.24rem;
      color: #404040;
    }
  }
}
</style>
